import { useTranslation } from '@thoughtspot/i18n';
import { Horizontal } from '@thoughtspot/radiant-react/widgets/layout';
import { LoadingIndicator } from '@thoughtspot/radiant-react/widgets/loading-indicator';
import { Table } from '@thoughtspot/radiant-react/widgets/table';
import { Colors, Typography, } from '@thoughtspot/radiant-react/widgets/typography/typography';
import React, { useEffect } from 'react';
import { useGetAdminCombinedNodeInfo } from "../../../../services/system/table-status-service/table-status-service";
import { Vertical } from "../../../../utils/layouts";
import styles from '../table-status-cards.module.scss';
import { NodeInfoColumns, prepareNodeRowDataEvents, } from '../table-status-cards/table-status-utils';
export const NodeInfoGridContainer = () => {
    const { t } = useTranslation();
    const { getAdminCombinedNodeInfo, data, loading, } = useGetAdminCombinedNodeInfo();
    useEffect(() => {
        getAdminCombinedNodeInfo();
    }, []);
    return (React.createElement(Vertical, { "data-testid": "node-info-testId", className: styles.tableComponent },
        React.createElement(Horizontal, null,
            React.createElement(Typography, { variant: "h3", color: Colors.base, noMargin: true }, t('adminUI.messages.SEARCH_DETAIL_NODE_TITLE'))),
        React.createElement(LoadingIndicator.Global, { className: styles.loader, hideLoader: !loading, "data-testid": "loader" }, data ? (React.createElement(Horizontal, null,
            React.createElement(Vertical, null,
                React.createElement(Horizontal, { className: styles.nodeTableComponent },
                    React.createElement(Table, { data: prepareNodeRowDataEvents(data.nodes), columns: NodeInfoColumns })),
                React.createElement(Horizontal, { className: styles.tableRowCountMarginTop },
                    React.createElement(Typography, { variant: "body-normal", color: Colors.base }, t('pagination_footer', {
                        total: data.nodes.length,
                    })))))) : null)));
};
//# sourceMappingURL=node-info-table.container.js.map